<!--<div class="absolute z-[100] left-[100px]" (click)="movie360()">Test from simulation</div>-->
<!--<div class="absolute z-[100]" (click)="test()">Test</div>-->

@if (isMovieSimulateTourShowing && isMovieDisplayingAttractions) {
@defer (on timer(1000)) {
<div [class.!top-[calc(10%-1rem)]]="mode === 'story'"
  class="absolute left-[calc(4%-1rem)] top-[calc(20%-1rem)] z-[51] rounded-full w-8 h-8 bg-[gold] flex justify-center items-center font-semibold text-black ig-fade-in mobile:fixed mobile:!top-[30%]">
  {{ attractionIndexInTourSimulation + 1 }}
</div>
}
}

<div *ngIf="isMovieSimulateTourShowing"
  class="absolute left-0 bg-[#0000008f] z-50 transition-all duration-1000 shadow-2xl ig-fade-in min-w-[330px]"
  [class.!bg-[#ffffffe8]]="mapStyle === 'light'" [class.!text-gray-600]="mapStyle === 'light'"
  [class.ig-iti-sim-map-wrap]="!isMovieDisplayingAttractions && mode === 'map'"
  [class.ig-iti-sim-story-wrap]="!isMovieDisplayingAttractions && mode === 'story'"
  [class.ig-iti-sim-map-wrap-attr]="isMovieDisplayingAttractions && mode === 'map'"
  [class.ig-iti-sim-story-wrap-attr]="isMovieDisplayingAttractions && mode === 'story'"
  [class.ig-iti-sim-story-wrap-mobile]="isMobile" [class.!bg-white]="isMobile && mode === 'story'">

  <p class="ig-iti-sim-title">
    <span class="ig-text-wrapper">
      <span class="ig-letters">{{ currentItinerary?.title }}</span>
    </span>
  </p>

  @if (!isMovieDisplayingAttractions) {
  <div class="w-[66%] relative my-[3vh] mx-auto transition-all duration-1000 ig-iti-sim-img"
    [class.animate-out-up-bottom]="isMovieDisplayingAttractions">
    <ig-image [src]="currentItinerary?.image"
      cls="rounded-lg max-h-[30vh] w-full !object-contain transition-all duration-1000"></ig-image>
  </div>
  }

  @defer (when isMovieDisplayingAttractions) {

  @if (attractionPreInTourSimulation) {
  @defer (on timer(1000)) {
  <div [class.animate-out-bottom-up-300]="isPreQuiting" class="flex items-center h-[90%]">
    <div class="animate-bottom-up">
      <div>
        <p class="text-sm">Prior to the No.{{ attractionIndexInTourSimulation + 1 }} stop</p>
        <p class="text-lg font-semibold my-8 text-[deepskyblue]">{{
          currentItinerary.attractions[attractionIndexInTourSimulation]?.item?.name }}</p>
        <p class="text-sm">{{ removeHtml(currentItinerary.attractions[attractionIndexInTourSimulation]?.preDescription)
          }}</p>
      </div>
    </div>
  </div>
  }
  }

  @if (attractionDisplayInTourSimulation) {
  @defer (on timer(1000)) {
  <div [class.animate-out-bottom-up-300]="isAttractionQuiting">
    <div class="w-full relative transition-all duration-1000 ig-iti-sim-img">
      <ig-image-gallery class="ig-fade-in"
        [images]="getImages(currentItinerary.attractions[attractionIndexInTourSimulation])"></ig-image-gallery>

      <div [class.!bg-[#ffffffb5]]="mapStyle === 'light'"
        class="absolute right-2 top-1 px-1 py-0 bg-[#0000008f] rounded-lg text-xs flex items-center z-50">
        <mat-icon class="!w-4 !h-4">star</mat-icon>
        <span>{{ currentItinerary.attractions[attractionIndexInTourSimulation]?.item?.rating }}</span>
      </div>

      <p [class.!text-white]="mapStyle === 'light'"
        class="text-xs absolute z-50 bottom-[-1px] w-full rounded-lg pt-4 pb-3 px-2 bg-gradient-to-b from-[transparent] to-[black]">
        {{ toReadable(currentItinerary.attractions[attractionIndexInTourSimulation]?.item?.category) }}
      </p>
    </div>

    <div class="p-2 animate-bottom-up ig-iti-sim-attr">
      <p class="text-lg font-semibold text-[deepskyblue]">{{
        currentItinerary.attractions[attractionIndexInTourSimulation]?.item?.name }}</p>
      <p class="text-sm">{{ currentItinerary.attractions[attractionIndexInTourSimulation]?.item?.address.address }}</p>
      <p class="text-sm mt-2">{{
        removeHtml(currentItinerary.attractions[attractionIndexInTourSimulation]?.item?.description) }}</p>
    </div>
  </div>
  }
  }

  @if (attractionPostInTourSimulation) {
  @defer (on timer(1000)) {
  <div [class.animate-out-bottom-up-300]="isPostQuiting" class="flex items-center h-[90%]">
    <div class="animate-bottom-up">
      <div>
        <p class="text-sm">After the No.{{ attractionIndexInTourSimulation + 1 }} stop</p>
        <p class="text-lg font-semibold my-8 text-[deepskyblue]">{{
          currentItinerary.attractions[attractionIndexInTourSimulation]?.item?.name }}</p>
        <p class="text-sm">{{ removeHtml(currentItinerary.attractions[attractionIndexInTourSimulation]?.postDescription)
          }}</p>
      </div>
    </div>
  </div>
  }
  }

  @if (attractionConnectionInTourSimulation) {
  @defer (on timer(1000)) {
  <div [class.ig-fade-out-300]="isConnectionQuiting" class="flex items-center h-[90%]">
    <div class="ig-fade-in w-full text-center">
      <div>
        <div class="text-sm">--&nbsp;
          <mat-icon class="translate-y-2.5">{{ travelModeIcon }}</mat-icon>
          <span>{{ attractionConnection }}&nbsp;--
          </span>
        </div>
      </div>
    </div>
  </div>
  }
  }
  }

  <div #simulateTextContainer
    class="ig-iti-sim-card-con w-[100%] flex items-center justify-center flex-wrap px-10 pt-1">
  </div>
</div>

<div *ngIf="isMovieSimulateTourShowing" [class.!bg-gray-700]="currentItinerary.mapStyle === 'dark'"
  class="w-[180px] rounded-full flex items-center gap-6 absolute bottom-6 left-[calc(50%-90px)] z-50 bg-white px-4 py-2 shadow-2xl cursor-pointer mobile:fixed"
  (click)="stop()">
  <div class="rounded-full p-4 bg-blue-500">
    <div class="w-5 h-5 rounded bg-white"></div>
  </div>
  <p class="text-blue-500 font-semibold text-xl" [class.!text-gray-200]="currentItinerary.mapStyle === 'dark'">STOP</p>
</div>

<div class="ig-iti-circle hidden absolute w-16 h-16 z-50 items-center flex justify-center">
  <div class="ig-inner-circle absolute rounded-full w-8 h-8 bg-[#ffffff61] transition-all "
    [class.!bg-[#ffd70061]]="mapStyle === 'light'">
  </div>
</div>